export const featuredComics = [
  {
    id: '1',
    title: '她的私密生活',
    author: '金作家',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%20style%2C%20beautiful%20female%20character%20with%20soft%20pastel%20pink%20background%2C%20clean%20minimal%20composition%2C%20warm%20lighting%2C%20anime%20inspired%20illustration%2C%20elegant%20and%20romantic%20atmosphere%2C%20soft%20shadows%2C%20high%20quality%20digital%20painting%20style%20with%20delicate%20details&width=600&height=850&seq=hanman-featured-01&orientation=portrait',
    rating: 4.8,
    status: '连载中',
    category: '恋爱',
    description: '一场意外让两个原本毫无交集的人走到了一起，他们在彼此的秘密中发现了爱情的真谛...',
    updateChapter: '第89话',
    bgColor: 'bg-accent-100/60',
    slug: 'her-secret-life',
  },
  {
    id: '2',
    title: '剑与魔法',
    author: '朴大神',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20art%2C%20male%20warrior%20with%20sword%2C%20magical%20glowing%20effects%2C%20mint%20green%20atmosphere%2C%20epic%20adventure%20style%2C%20clean%20composition%2C%20soft%20cinematic%20lighting%2C%20high%20quality%20digital%20art%20with%20dramatic%20shadows&width=600&height=850&seq=hanman-featured-02&orientation=portrait',
    rating: 4.9,
    status: '连载中',
    category: '奇幻',
    description: '在剑与魔法交织的世界里，一位平凡少年踏上了成为最强魔法剑士的冒险之旅...',
    updateChapter: '第156话',
    bgColor: 'bg-secondary-100/60',
    slug: 'sword-and-magic',
  },
  {
    id: '3',
    title: '暗夜追踪',
    author: '李侦探',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20cover%2C%20dark%20mysterious%20atmosphere%2C%20detective%20character%20in%20urban%20night%20scene%2C%20muted%20gray%20tones%2C%20clean%20composition%2C%20noir%20style%20illustration%2C%20high%20quality%20digital%20painting%20with%20dramatic%20lighting&width=600&height=850&seq=hanman-featured-03&orientation=portrait',
    rating: 4.7,
    status: '已完结',
    category: '悬疑',
    description: '一桩离奇的失踪案牵扯出隐藏在都市背后的巨大阴谋，真相究竟在何处...',
    updateChapter: '全120话',
    bgColor: 'bg-background-200/70',
    slug: 'night-tracking',
  },
  {
    id: '4',
    title: '热血高校',
    author: '崔教练',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20action%20cover%2C%20young%20male%20character%20with%20determined%20expression%2C%20warm%20beige%20and%20golden%20background%2C%20sports%20theme%2C%20clean%20composition%2C%20energetic%20style%20illustration%2C%20high%20quality%20digital%20art%20with%20soft%20natural%20lighting&width=600&height=850&seq=hanman-featured-04&orientation=portrait',
    rating: 4.6,
    status: '连载中',
    category: '动作',
    description: '转学生来到一所充满热血与梦想的高中，他能否带领球队走向全国大赛的巅峰...',
    updateChapter: '第67话',
    bgColor: 'bg-accent-50/80',
    slug: 'hot-blood-highschool',
  },
];

export const rankingComics = [
  { rank: 1, title: '她的私密生活', category: '恋爱', rating: 4.8, views: '1.2亿', trend: 'up', slug: 'her-secret-life' },
  { rank: 2, title: '剑与魔法', category: '奇幻', rating: 4.9, views: '9800万', trend: 'up', slug: 'sword-and-magic' },
  { rank: 3, title: '重生之我是大明星', category: '都市', rating: 4.7, views: '8500万', trend: 'up', slug: 'reborn-star' },
  { rank: 4, title: '暗夜追踪', category: '悬疑', rating: 4.7, views: '7200万', trend: 'down', slug: 'night-tracking' },
  { rank: 5, title: '甜蜜陷阱', category: '恋爱', rating: 4.5, views: '6800万', trend: 'up', slug: 'sweet-trap' },
  { rank: 6, title: '末日后记', category: '科幻', rating: 4.6, views: '6100万', trend: 'new', slug: 'post-apocalypse' },
  { rank: 7, title: '热血高校', category: '动作', rating: 4.6, views: '5500万', trend: 'up', slug: 'hot-blood-highschool' },
  { rank: 8, title: '我的契约男友', category: '恋爱', rating: 4.4, views: '4900万', trend: 'down', slug: 'contract-boyfriend' },
  { rank: 9, title: '神之塔', category: '奇幻', rating: 4.9, views: '4300万', trend: 'up', slug: 'tower-of-god' },
  { rank: 10, title: '便利店新星', category: '日常', rating: 4.3, views: '3800万', trend: 'new', slug: 'convenience-star' },
];

export const latestUpdates = [
  { id: '1', title: '她的私密生活', chapter: '第89话', updatedAt: '2小时前', slug: 'her-secret-life' },
  { id: '2', title: '剑与魔法', chapter: '第156话', updatedAt: '3小时前', slug: 'sword-and-magic' },
  { id: '3', title: '重生之我是大明星', chapter: '第42话', updatedAt: '5小时前', slug: 'reborn-star' },
  { id: '4', title: '甜蜜陷阱', chapter: '第55话', updatedAt: '6小时前', slug: 'sweet-trap' },
  { id: '5', title: '热血高校', chapter: '第67话', updatedAt: '8小时前', slug: 'hot-blood-highschool' },
  { id: '6', title: '神之塔', chapter: '第512话', updatedAt: '10小时前', slug: 'tower-of-god' },
  { id: '7', title: '末日后记', chapter: '第33话', updatedAt: '12小时前', slug: 'post-apocalypse' },
  { id: '8', title: '便利店新星', chapter: '第78话', updatedAt: '1天前', slug: 'convenience-star' },
];

export const stats = {
  totalComics: '12,580+',
  dailyReaders: '350万+',
  satisfaction: '98%',
  totalViews: '50亿+',
};

export const testimonials = [
  {
    id: '1',
    name: '小雨',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20female%20portrait%20avatar%2C%20young%20woman%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot%20style%2C%20gentle%20expression&width=120&height=120&seq=hanman-avatar-01&orientation=squarish',
    role: '忠实读者 · 3年',
    rating: 5,
    content: '韩漫漫画网站真的是我每天必刷的平台！更新速度超快，画质高清，而且完全免费无广告。推荐给所有喜欢看韩漫的朋友们！',
  },
  {
    id: '2',
    name: '星辰大海',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20male%20portrait%20avatar%2C%20young%20man%20with%20friendly%20expression%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20professional%20headshot%2C%20casual%20style&width=120&height=120&seq=hanman-avatar-02&orientation=squarish',
    role: '漫画爱好者 · 2年',
    rating: 5,
    content: '这里的分类做得特别好，找漫画非常方便。排行榜也很有参考价值，帮我发现了好多宝藏韩漫，已经推荐给身边所有朋友了。',
  },
  {
    id: '3',
    name: '樱花飘落',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20female%20portrait%20avatar%2C%20cute%20young%20woman%2C%20gentle%20smile%2C%20soft%20warm%20lighting%2C%20clean%20background%2C%20natural%20expression%2C%20professional%20headshot%20style&width=120&height=120&seq=hanman-avatar-03&orientation=squarish',
    role: 'VIP读者 · 1年',
    rating: 5,
    content: '下拉式阅读体验太棒了！不用翻页，一口气能看好多话。画质清晰，加载速度也快，是我用过最好用的韩漫阅读平台。',
  },
  {
    id: '4',
    name: '漫画次元',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20male%20portrait%20avatar%2C%20young%20man%20with%20glasses%2C%20intellectual%20look%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20professional%20headshot%20style&width=120&height=120&seq=hanman-avatar-04&orientation=squarish',
    role: '资深读者 · 4年',
    rating: 4,
    content: '韩漫大全真的很全，我想看的韩漫基本都能在这里找到。更新也很及时，每次新章节上线第一时间就能看到。',
  },
  {
    id: '5',
    name: '月下独酌',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20female%20portrait%20avatar%2C%20elegant%20young%20woman%2C%20warm%20gentle%20smile%2C%20clean%20background%2C%20soft%20natural%20lighting%2C%20professional%20headshot%2C%20artistic%20vibe&width=120&height=120&seq=hanman-avatar-05&orientation=squarish',
    role: '新读者 · 6个月',
    rating: 5,
    content: '最开始是被朋友安利来的，没想到一入坑就停不下来！界面简洁好看，阅读体验非常好，强烈推荐！',
  },
  {
    id: '6',
    name: '追风少年',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20male%20portrait%20avatar%2C%20energetic%20young%20man%2C%20bright%20smile%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20professional%20headshot%2C%20youthful%20style&width=120&height=120&seq=hanman-avatar-06&orientation=squarish',
    role: '热血粉丝 · 2年',
    rating: 5,
    content: '动作类和奇幻类的韩漫资源特别丰富，排行榜更新也很勤快。每天来刷一刷，总能发现好看的新作品。',
  },
];

export const faqs = [
  {
    question: '韩漫漫画网站是免费的吗？',
    answer: '是的，韩漫漫画网站完全免费！我们致力于为所有韩漫爱好者提供无广告、高质量的阅读体验。所有漫画内容均可免费下拉式阅读，无需付费或订阅。',
  },
  {
    question: '如何找到我想看的韩漫？',
    answer: '您可以通过多种方式找到心仪的韩漫：使用首页搜索框直接搜索漫画名称；浏览分类页面按题材（恋爱、奇幻、动作、悬疑等）筛选；查看排行榜发现热门作品；关注首页的"热门推荐"区域获取编辑精选。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '我们会在漫画作者发布新章节后的第一时间同步更新，确保读者能够及时看到最新内容。热门连载作品通常每周更新1-2话，具体更新频率取决于原作的发布节奏。',
  },
  {
    question: '支持哪些设备阅读？',
    answer: '韩漫漫画网站采用响应式设计，完美支持桌面电脑、平板和手机等多种设备。无论您使用什么设备，都能享受高清、流畅的下拉式阅读体验。',
  },
  {
    question: '为什么选择下拉式阅读方式？',
    answer: '下拉式阅读是韩漫的标准阅读方式，相比传统翻页模式更加流畅自然。您只需向下滚动即可连续阅读，无需点击翻页按钮，阅读体验更加沉浸和舒适。',
  },
];

export const platformFeatures = [
  {
    id: '1',
    icon: 'ri-book-open-line',
    title: '海量韩漫资源',
    description: '收录超过12,580部韩国漫画，涵盖恋爱、奇幻、动作、悬疑、科幻等全品类题材，不断更新扩充中。',
    bgStyle: 'bg-primary-500',
  },
  {
    id: '2',
    icon: 'ri-smartphone-line',
    title: '高清下拉式阅读',
    description: '独创下拉式阅读体验，高清画质呈现每一格画面，流畅自然，无需翻页，沉浸式感受韩漫魅力。',
    bgStyle: 'bg-cover bg-center',
    bgImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20reading%20experience%20on%20mobile%20phone%2C%20clean%20minimal%20interface%2C%20soft%20warm%20lighting%2C%20cozy%20atmosphere%2C%20modern%20digital%20reading%20concept%2C%20high%20quality%20editorial%20photography%20style&width=800&height=500&seq=hanman-feature-02&orientation=landscape',
  },
  {
    id: '3',
    icon: 'ri-shield-check-line',
    title: '无广告纯净体验',
    description: '坚持无广告原则，为读者打造纯粹、干净的阅读环境。没有弹窗、没有横幅，只有最纯粹的韩漫阅读乐趣。',
    bgStyle: 'bg-secondary-500',
  },
];

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '漫画大全', href: '/category' },
  { label: '排行榜', href: '/#ranking' },
  { label: '分类', href: '/category' },
  { label: '关于我们', href: '/about' },
];